module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0049.jpg?v=27494e34";